import axios from 'axios';
import md5 from 'js-md5';

import { ElMessage } from "element-plus";
/**
* 定义请求常量
* TIME_OUT、ERR_OK
*/
export const TIME_OUT = 1000000;    // 请求超时时间
export const ERR_OK = true;      // 请求成功返回状态，字段和后台统一
let a = location.host.includes('www.numatch.com.hk');
export const baseUrl = !a ? 'https://apiuat.cresz.com.cn/openapi/?model=rs' : 'https://openapi.cresmartech.com/openapi/?model=rs'   // 引入全局url，定义在全局变量process.env中
let Version =  !a ? '1.0.0' : '1.0.0'
let App_ID =  !a ? '1000000114GA' : '1000000114GA'
let Partner_ID =  !a ? '10000000' : '10000000'
let AppKey = !a? 'da10503e096c425694385781fe4a1355' : 'da10503e096c425694385781fe4a1355'
let Sys_ID = !a ? '10000001' : '10000001'

export const FormatDateTime = (date) => {
  let year = date.getFullYear();
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let minsecond = date.getMilliseconds()
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second + ':' + minsecond
}

export const Sign = (apiAttrs, data) => {

  //签名需要用到REQUEST_DATA
  apiAttrs.REQUEST_DATA = data
  let sign = ''
  //将待签名数据进行ascii排序
  let datas = Object.keys(apiAttrs).sort()
  //拼接待签名字符串
  datas.forEach(item => {
      sign += item + '=' + apiAttrs[item] + '&'
  })
  sign += AppKey
  //md5加密签名
  sign = md5(sign).toString().toUpperCase()
  // sign = md5(sign).toString().toUpperCase()
  delete apiAttrs.REQUEST_DATA;
  return sign
}

const ERROR_API_LIST = new Map();
export const HandleApiAttrs = (attrs, data) => {

  if (!attrs.Api_ID) attrs.Api_ID = ''
  if (!attrs.Api_Version) attrs.Api_Version = Version
  // if (!attrs.App_ID) attrs.App_ID = App_ID
  if (!attrs.Sys_ID) attrs.Sys_ID = Sys_ID
  if (!attrs.App_Sub_ID) attrs.App_Sub_ID = App_ID
  if (!attrs.App_Token) attrs.App_Token = 'a58783b2be9b4150ad32f365f8184186'
  // if (!attrs.App_Version) attrs.App_Version = '1.0.0'
  // if (!attrs.Divice_ID) attrs.Divice_ID = 'IOS'
  // if (!attrs.Divice_Version) attrs.Divice_Version = "Iphone1.2"
  // if (!attrs.OS_Version) attrs.OS_Version = '2.3'
  if (!attrs.Partner_ID) attrs.Partner_ID = Partner_ID
  if (!attrs.Time_Stamp) attrs.Time_Stamp = FormatDateTime(new Date())
  if (!attrs.User_Token) attrs.User_Token = ''
  data = JSON.stringify(data)
  attrs.Sign = Sign(attrs, data)
  return attrs
}

// 请求超时时间
axios.defaults.timeout = TIME_OUT

// 封装请求拦截
axios.interceptors.request.use(
	config => {
    let REQUEST_DATA = {}
    let API_ATTRS = {}
    config.headers['Content-Type'] = 'application/json;charset=utf-8;'
    REQUEST_DATA = config.data.params
    API_ATTRS = HandleApiAttrs({Api_ID: config.data.Api_ID}, config.data.params)
    config.data = {REQUEST: {API_ATTRS: API_ATTRS, REQUEST_DATA: REQUEST_DATA} }
    return config
	},
	error => {
		return Promise.reject(error)
	}
)
// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
  response => {
    if (response.data.RESPONSE.RETURN_CODE == 'S0A00000') {
      let data = response.data.RESPONSE.RETURN_DATA
      if (data.errCode != 200) {
        ElMessage.error(data.errMsg)
      } else{
        data.RETURN_STAMP = response.data.RESPONSE.RETURN_STAMP
        return Promise.resolve(data)
      }
    } else {
      ElMessage.error(response.data.RESPONSE.RETURN_DESC)
      if (response.data.RESPONSE.RETURN_CODE == 'E0S00022') {
        window.localStorage.removeItem('AIIndex_Token')
        return Promise.reject(response.data.RESPONSE.RETURN_DESC)
      }
    }
  },
  error => {
    console.warn('请求失败的接口', ERROR_API_LIST)
    return Promise.reject(error)
  }
)
function getUrl(url) {
  return {
    'cre.cresys.ISUNG.test':	'/isung-oauth-server/api/helloworld',
    'cre.cresys.ISUNG.oauth2.token':	'/isung-oauth-server/oauth/token',
    'cre.cresys.ISUNG.order.list':	'/isung-order-api/api/order/list',
    'cre.cresys.ISUNG.order.getOne':	'/isung-order-api/api/order/getOne',
    'cre.cresys.ISUNG.adminOrder.list':	'/isung-order-adminapi/api/adminOrder/list',
    'cre.cresys.ISUNG.adminOrder.update':	'/isung-order-adminapi/api/adminOrder/update',
    'cre.cresys.ISUNG.order.add':	'/isung-order-api/api/order/add',
    'cre.cresys.ISUNG.order.update':	'/isung-order-api/api/order/update',
    'cre.cresys.ISUNG.login':	'/isung-oauth-server/loginByOpenApi',
    'cre.cresys.ISUNG.logout':	'/isung-oauth-server/logout',
    'cre.cresys.ISUNG.category.list':	'/isung-order-api/category/list',
    'cre.cresys.ISUNG.goods.goodsDetail':	'/isung-order-api/goods/goodsDetail',
    'cre.cresys.ISUNG.rotationImg.list':	'/isung-order-api/rotationImg/list',
    'cre.cresys.ISUNG.holidayDate.list':	'/isung-order-api/holidayDate/list',
    'cre.cresys.ISUNG.admin.category.list':	'/isung-order-adminapi/category/list',
    'cre.cresys.ISUNG.category.allList':	'/isung-order-adminapi/category/allList',
    'cre.cresys.ISUNG.category.add':	'/isung-order-adminapi/category/add',
    'cre.cresys.ISUNG.category.update':	'/isung-order-adminapi/category/update',
    'cre.cresys.ISUNG.dictionaries.list':	'/isung-order-adminapi/dictionaries/list',
    'cre.cresys.ISUNG.dictionaries.add':	'/isung-order-adminapi/dictionaries/add',
    'cre.cresys.ISUNG.dictionaries.update':	'/isung-order-adminapi/dictionaries/update',
    'cre.cresys.ISUNG.goods.list':	'/isung-order-adminapi/goods/list',
    'cre.cresys.ISUNG.goods.allList':	'/isung-order-adminapi/goods/allList',
    'cre.cresys.ISUNG.goods.add':	'/isung-order-adminapi/goods/add',
    'cre.cresys.ISUNG.goods.update':	'/isung-order-adminapi/goods/update',
    'cre.cresys.ISUNG.goods.goodsImgList':	'/isung-order-adminapi/goods/goodsImgList',
    'cre.cresys.ISUNG.goods.addGoodsImg':	'/isung-order-adminapi/goods/addGoodsImg',
    'cre.cresys.ISUNG.goods.updateGoodsImg':	'/isung-order-adminapi/goods/updateGoodsImg',
    'cre.cresys.ISUNG.goods.goodsRelationList':	'/isung-order-adminapi/goods/goodsRelationList',
    'cre.cresys.ISUNG.goods.addGoodsRelation':	'/isung-order-adminapi/goods/addGoodsRelation',
    'cre.cresys.ISUNG.admin.holidayDate.list':	'/isung-order-adminapi/holidayDate/list',
    'cre.cresys.ISUNG.holidayDate.allList':	'/isung-order-adminapi/holidayDate/allList',
    'cre.cresys.ISUNG.holidayDate.add':	'/isung-order-adminapi/holidayDate/add',
    'cre.cresys.ISUNG.holidayDate.update':	'/isung-order-adminapi/holidayDate/update',
    'cre.cresys.ISUNG.admin.rotationImg.list':	'/isung-order-adminapi/rotationImg/list',
    'cre.cresys.ISUNG.rotationImg.allList':	'/isung-order-adminapi/rotationImg/allList',
    'cre.cresys.ISUNG.rotationImg.add':	'/isung-order-adminapi/rotationImg/add',
    'cre.cresys.ISUNG.rotationImg.update':	'/isung-order-adminapi/rotationImg/update',
    'cre.cresys.ISUNG.tags.list':	'/isung-order-adminapi/tags/list',
    'cre.cresys.ISUNG.tags.allList':	'/isung-order-adminapi/tags/allList',
    'cre.cresys.ISUNG.tags.add':	'/isung-order-adminapi/tags/add',
    'cre.cresys.ISUNG.tags.update':	'/isung-order-adminapi/tags/update',
    'cre.cresys.ISUNG.tags.goodsTagsList':	'/isung-order-adminapi/tags/goodsTagsList',
    'cre.cresys.ISUNG.tags.addGoodsTags':	'/isung-order-adminapi/tags/addGoodsTags',
    'cre.cresys.ISUNG.holidayDate.testHolidayDateList':	'/isung-order-api/holidayDate/testHolidayDateList',
    'cre.cresys.ISUNG.shelf':	'/isung-order-adminapi/goods/shelf',
    'cre.cresys.ISUNG.goods.shelf':	'/isung-order-adminapi/goods/shelf',
    'cre.cresys.ISUNG.order.api.adminOrder.download':	'/isung-order-adminapi/api/adminOrder/download',
    'cre.cresys.ISUNG.admin.stores.list':	'/isung-order-adminapi/stores/list',
    'cre.cresys.ISUNG.stores.allList':	'/isung-order-adminapi/stores/allList',
    'cre.cresys.ISUNG.stores.add':	'/isung-order-adminapi/stores/add',
    'cre.cresys.ISUNG.stores.update':	'/isung-order-adminapi/stores/update',
    'cre.cresys.ISUNG.stores.list':	'/isung-order-api/stores/list',
    'cre.cresys.ISUNG.emailTemplate.list':	'/isung-order-adminapi/emailTemplate/list',
    'cre.cresys.ISUNG.emailTemplate.add':	'/isung-order-adminapi/emailTemplate/add',
    'cre.cresys.ISUNG.emailTemplate.update':	'/isung-order-adminapi/emailTemplate/update',
    'cre.cresys.ISUNG.dictionaries.allList':	'/isung-order-adminapi/dictionaries/allList',
    'cre.cresys.ISUNG.messageLog.list':	'/isung-order-adminapi/messageLog/list',
    'cre.cresys.ISUNG.dictionaries.primaryCodeList':	'/isung-order-adminapi/dictionaries/primaryCodeList',
    'cre.cresys.ISUNG.afterSales.afterSalesList':	'/isung-order-api/afterSales/afterSalesList',
    'cre.cresys.ISUNG.adminAfterSales.applyForAfterSales':	'/isung-order-adminapi/adminAfterSales/applyForAfterSales',
    'cre.cresys.ISUNG.adminAfterSales.afterSalesList':	'/isung-order-adminapi/adminAfterSales/afterSalesList',
    'cre.cresys.ISUNG.adminAfterSales.dealWithARefund':	'/isung-order-adminapi/adminAfterSales/dealWithARefund',
    'cre.cresys.ISUNG.user.list':	'/isung-order-adminapi/user/list',
    'cre.cresys.ISUNG.user.add':	'/isung-order-adminapi/user/add',
    'cre.cresys.ISUNG.user.update':	'/isung-order-adminapi/user/update',
    'cre.cresys.ISUNG.user.allList':	'/isung-order-adminapi/user/allList',
    'cre.cresys.ISUNG.apiUser.add':	'/isung-order-api/apiUser/add',
    'cre.cresys.ISUNG.apiDictionaries.list':	'/isung-order-api/apiDictionaries/list',
    'cre.cresys.ISUNG.register':	'/isung-oauth-server/register',
    'cre.cresys.ISUNG.addOpinion':	'/isung-order-api/apiUser/addOpinion',
    'cre.cresys.ISUNG.apiUser.list':	'/isung-order-api/apiUser/list',
    'cre.cresys.ISUNG.opinionList':	'/isung-order-api/apiUser/opinionList',
    'cre.cresys.ISUNG.secondDictionariesList':	'/isung-order-adminapi/dictionaries/secondDictionariesList',
    'cre.cresys.ISUNG.nuMatch.list':	'/isung-order-adminapi/nuMatch/list',
    'cre.cresys.ISUNG.nuMatch.add':	'/isung-order-adminapi/nuMatch/add',
    'cre.cresys.ISUNG.nuMatch.update':	'/isung-order-adminapi/nuMatch/update',
    'cre.cresys.ISUNG.nuMatchDetailsList':	'/isung-order-adminapi/nuMatch/nuMatchDetailsList',
    'cre.cresys.ISUNG.addNuMatchDetails':	'/isung-order-adminapi/nuMatch/addNuMatchDetails',
    'cre.cresys.ISUNG.updateNuMatchDetails':	'/isung-order-adminapi/nuMatch/updateNuMatchDetails',
    'cre.cresys.ISUNG.userComments.list':	'/isung-order-adminapi/userComments/list',
    'cre.cresys.ISUNG.userComments.add':	'/isung-order-adminapi/userComments/add',
    'cre.cresys.ISUNG.userComments.update':	'/isung-order-adminapi/userComments/update',
    'cre.cresys.ISUNG.apiNuMatch.list':	'/isung-order-api/api/nuMatch/list',
    'cre.cresys.ISUNG.apiNuMatch.nuMatchDetailsList':	'/isung-order-api/api/nuMatch/nuMatchDetailsList',
    'cre.cresys.ISUNG.outletsGoodsList':	'/isung-order-adminapi/outlets/outletsGoodsList',
    'cre.cresys.ISUNG.updateOutletsGoods':	'/isung-order-adminapi/outlets/updateOutletsGoods',
    'cre.cresys.ISUNG.outletsTemplateList':	'/isung-order-adminapi/outlets/outletsTemplateList',
    'cre.cresys.ISUNG.addOutletsTemplate':	'/isung-order-adminapi/outlets/addOutletsTemplate',
    'cre.cresys.ISUNG.updateOutletsTemplate':	'/isung-order-adminapi/outlets/updateOutletsTemplate',
    'cre.cresys.ISUNG.outletsTemplateDetailList':	'/isung-order-adminapi/outlets/outletsTemplateDetailList',
    'cre.cresys.ISUNG.addOutletsTemplateDetail':	'/isung-order-adminapi/outlets/addOutletsTemplateDetail',
    'cre.cresys.ISUNG.updateOutletsTemplateDetail':	'/isung-order-adminapi/outlets/updateOutletsTemplateDetail',
    'cre.cresys.ISUNG.api.outletsGoodsList':	'/isung-order-api/api/outlets/list',
    'cre.cresys.ISUNG.api.userCommentsList':	'/isung-order-api/api/userComments/list',
    'cre.cresys.ISUNG.nutrientBasedataList':	'/isung-order-adminapi/nutrient/nutrientBasedataList',
    'cre.cresys.ISUNG.nutrientBasedataAllList':	'/isung-order-adminapi/nutrient/nutrientBasedataAllList',
    'cre.cresys.ISUNG.addNutrientBasedata':	'/isung-order-adminapi/nutrient/addNutrientBasedata',
    'cre.cresys.ISUNG.updateNutrientBasedata':	'/isung-order-adminapi/nutrient/updateNutrientBasedata',
    'cre.cresys.ISUNG.nutrientDetailList':	'/isung-order-adminapi/nutrient/nutrientDetailList',
    'cre.cresys.ISUNG.addNutrientDetail':	'/isung-order-adminapi/nutrient/addNutrientDetail',
    'cre.cresys.ISUNG.updateNutrientDetail':	'/isung-order-adminapi/nutrient/updateNutrientDetail',
    'cre.cresys.ISUNG.userNutrientDetailList':	'/isung-order-adminapi/nutrient/userNutrientDetailList',
    'cre.cresys.ISUNG.updateUserNutrientDetail':	'/isung-order-adminapi/nutrient/updateUserNutrientDetail',
    'cre.cresys.ISUNG.api.nutrientBasedataList':	'/isung-order-api/api/nutrient/nutrientBasedataList',
    'cre.cresys.ISUNG.api.userNutrientDetailList':	'/isung-order-api/api/nutrient/userNutrientDetailList',
    'cre.cresys.ISUNG.addUserUserNutrientDetail':	'/isung-order-adminapi/nutrient/addUserUserNutrientDetail',
    'cre.cresys.ISUNG.addOutletsGoodsList':	'/isung-order-adminapi/outlets/addOutletsGoodsList',
    'cre.cresys.ISUNG.deleteNuMatchDetails':	'/isung-order-adminapi/nuMatch/deleteNuMatchDetails',
    'cre.cresys.ISUNG.integral.getIntegralInfo':	'/isung-order-api/integral/getIntegralInfo',
    'cre.cresys.ISUNG.integral.getIntegralDetailInfo':	'/isung-order-api/integral/getIntegralDetailInfo',
    'cre.cresys.ISUNG.transaction.orderPayment':	'/isung-order-api/transaction/orderPayment',
    'cre.cresys.ISUNG.transaction.getTransactionInfo':	'/isung-order-api/transaction/getTransactionInfo',
    'cre.cresys.ISUNG.adminSalesVolume.list':	'/isung-order-adminapi/admin/salesVolume/list',
    'cre.cresys.ISUNG.account.checkExists':	'/isung-oauth-server/account/checkExists',
    'cre.cresys.ISUNG.account.resetPassword':	'/isung-oauth-server/account/resetPassword',
    'cre.cresys.ISUNG.account.forgetPassword':	'/isung-oauth-server/account/forgetPassword',
    'cre.cresys.ISUNG.account.sendVerifiedCode':	'/isung-oauth-server/account/sendVerifiedCode',
    'cre.cresys.ISUNG.integral.userDynamicPanelData':	'/isung-order-api/integral/userDynamicPanelData',
    'cre.cresys.ISUNG.account.info':	'/isung-oauth-server/account/info',
    'cre.cresys.ISUNG.isHolidayDate':	'/isung-order-api/holidayDate/isHolidayDate',
    'cre.cresys.ISUNG.goodsPriceList':	'/isung-order-adminapi/goods/goodsPriceList',
    'cre.cresys.ISUNG.addGoodsPrice':	'/isung-order-adminapi/goods/addGoodsPrice',
    'cre.cresys.ISUNG.updateGoodsPrice':	'/isung-order-adminapi/goods/updateGoodsPrice',
    'cre.cresys.ISUNG.api.goodsStockList':	'/isung-order-api/api/outlets/goodsStockList',
    'cre.cresys.ISUNG.userAccountList':	'/isung-order-adminapi/user/userAccountList',
    'cre.cresys.ISUNG.order.updateGetFoodTime':	'/isung-order-api/api/order/updateGetFoodTime',
    'cre.cresys.ISUNG.goodsExcel':	'/isung-order-adminapi/goods/goodsExcel',
    'cre.cresys.ISUNG.goodsRelationExcel':	'/isung-order-adminapi/goods/goodsRelationExcel',
    'cre.cresys.ISUNG.order.updateOrderStatus':	'/isung-order-api/api/orderStatus/updateOrderStatus',
    'cre.cresys.ISUNG.outletsTemplateDetailExcel':	'/isung-order-adminapi/outlets/outletsTemplateDetailExcel',
    'cre.cresys.ISUNG.downloadOutletsTemplateDetail':	'/isung-order-adminapi/outlets/downloadOutletsTemplateDetail',
    'cre.cresys.ISUNG.menuChildTree':	'/isung-oauth-server/menu/childTree',
    'cre.cresys.ISUNG.outletsGoodsListByDate':	'/isung-order-api/api/outlets/goodsListByDate',
    'cre.cresys.ISUNG.orderableDateList':	'/isung-order-api/holidayDate/orderableDateList',
    'cre.cresys.ISUNG.businessPageList':	'/isung-order-adminapi/business/pageList',
    'cre.cresys.ISUNG.businessGet':	'/isung-order-adminapi/business/get',
    'cre.cresys.ISUNG.businessSave':	'/isung-order-adminapi/business/save',
    'cre.cresys.ISUNG.businessDelete':	'/isung-order-adminapi/business/delete',
    'cre.cresys.ISUNG.menuTree':	'/isung-oauth-server/menu/treePC',
    'cre.cresys.ISUNG.menuSave':	'/isung-oauth-server/menu/save',
    'cre.cresys.ISUNG.menuDelete':	'/isung-oauth-server/menu/delete',
    'cre.cresys.ISUNG.menuGet':	'/isung-oauth-server/menu/get',
    'cre.cresys.ISUNG.menuGetRoleMenuList':	'/isung-oauth-server/menu/getRoleMenuList',
    'cre.cresys.ISUNG.roleSave':	'/isung-oauth-server/role/save',
    'cre.cresys.ISUNG.roleGet':	'/isung-oauth-server/role/get',
    'cre.cresys.ISUNG.rolePageList':	'/isung-oauth-server/role/listPC',
    'cre.cresys.ISUNG.roleInuse':	'/isung-oauth-server/role/inuse',
    'cre.cresys.ISUNG.businessList':	'/isung-order-adminapi/business/list',
    'cre.cresys.ISUNG.adminOrder.store.orderDetail':	'/isung-order-adminapi/api/adminOrder/store/orderDetail',
    'cre.cresys.ISUNG.adminOrder.store.distribution':	'/isung-order-adminapi/api/adminOrder/store/distribution',
    'cre.cresys.ISUNG.adminOrder.business.orderDetail':	'/isung-order-adminapi/api/adminOrder/business/orderDetail',
    'cre.cresys.ISUNG.adminOrder.business.distribution':	'/isung-order-adminapi/api/adminOrder/business/distribution',
    'cre.cresys.ISUNG.sysUserGet':	'/isung-oauth-server/sysUser/get',
    'cre.cresys.ISUNG.sysUserList':	'/isung-oauth-server/sysUser/list',
    'cre.cresys.ISUNG.sysUserPageList':	'/isung-oauth-server/sysUser/pageList',
    'cre.cresys.ISUNG.sysUserSave':	'/isung-oauth-server/sysUser/save',
    'cre.cresys.ISUNG.sysUserInuse':	'/isung-oauth-server/sysUser/inuse',
    'cre.cresys.ISUNG.sysUserUpdatePassword':	'/isung-oauth-server/sysUser/updatePassword',
    'cre.cresys.ISUNG.user.order.mainOrder':	'/isung-order-api/api/user/order/mainOrder',
    'cre.cresys.ISUNG.user.order.dayOrder':	'/isung-order-api/api/user/order/dayOrder',
    'cre.cresys.ISUNG.outletsAddOutletsGoods':	'/isung-order-adminapi/outlets/addOutletsGoods',
    'cre.cresys.ISUNG.outletsGoodsTemplate':	'/isung-order-adminapi/outlets/goodsTemplate',
    'cre.cresys.ISUNG.outletsImportExcel':	'/isung-order-adminapi/outlets/importExcel',
    'cre.cresys.ISUNG.adminOrder.sync.hnzczy':	'/isung-order-adminapi/api/adminOrder/sync/hnzczy',
    'cre.cresys.ISUNG.apiUserAccountAllList':	'/isung-order-api/apiUser/accountAllList',
    'cre.cresys.ISUNG.apiUserAddAccount':	'/isung-order-api/apiUser/addAccount',
    'cre.cresys.ISUNG.apiUserAccountPageList':	'/isung-order-api/apiUser/accountPageList',
    'cre.cresys.ISUNG.qrcode.generate':	'/isung-order-api/api/qrcode/generate',
    'cre.cresys.ISUNG.cargoLaneQueryGoods':	'/isung-order-api/cargoLane/queryGoods',
    'cre.cresys.ISUNG.goodsImportTemplate':	'/isung-order-adminapi/goods/importTemplate',
    'cre.cresys.ISUNG.qrcode.pickup':	'/isung-order-api/api/hnzczy/qrcode/pickup',
    'cre.cresys.ISUNG.qrcode.statusPolling':	'/isung-order-api/api/hnzczy/pickup/statusPolling',
    'cre.cresys.ISUNG.cargoLaneUpdate':	'/isung-order-api/cargoLane/update',
    'cre.cresys.ISUNG.stockGoodsList':	'/isung-order-api/goods/stockGoodsList',
    'cre.cresys.ISUNG.order.pausedOrderInfo':	'/isung-order-api/api/order/pausedOrderInfo',
    'cre.cresys.ISUNG.machinesGoodsClear':	'/isung-order-api/cargoLane/machinesGoods/clear',
    'cre.cresys.ISUNG.businessDistribution.download':	'/isung-order-adminapi/api/adminOrder/business/distribution/download',
    'cre.cresys.ISUNG.storeDistribution.download':	'/isung-order-adminapi/api/adminOrder/store/distribution/download',
    'cre.app.ISUNG.cosGetSts':	'/isung-order-adminapi/cos/getSts',
    'cre.app.ISUNG.orderUserWaitFor':	'/isung-order-api/api/order/userWaitFor',
    'cre.app.ISUNG.qrcodeJumpUrl':	'/isung-order-api/api/qrcode/jumpUrl',
    'cre.app.ISUNG.adminOrderSync':	'/isung-order-adminapi/api/adminOrder/sync',
    'cre.app.ISUNG.adminOrderCancel':	'/isung-order-adminapi/api/adminOrder/cancel',
    'cre.app.ISUNG.order.sync.hnzczy':	'/isung-order-api/api/order/sync/hnzczy',
    'cre.app.ISUNG.order.sync.cancelOrder':	'/isung-order-api/api/order/sync/cancelOrder',
    'cre.app.ISUNG.roleGetByUserId':	'/isung-oauth-server/role/getByUserId',
    'cre.cresys.ISUNG.outletsAddByDate':	'/isung-order-adminapi/outlets/addByDate',
    'cre.cresys.ISUNG.adminOrder.store.classifyCount':	'/isung-order-adminapi/api/adminOrder/store/classifyCount',
    'cre.cresys.ISUNG.adminOrder.business.classifyCount':	'/isung-order-adminapi/api/adminOrder/business/classifyCount',
    'cre.cresys.ISUNG.adminOrder.updateReceipt':	'/isung-order-adminapi/api/adminOrder/updateReceipt',
    'cre.cresys.ISUNG.adminOrder.summaryByUser':	'/isung-order-adminapi/api/adminOrder/summaryByUser',
    'cre.cresys.ISUNG.adminOrder.updateByUser':	'/isung-order-adminapi/api/adminOrder/updateByUser',
    'cre.cresys.ISUNG.stores.getByMachinesId':	'/isung-order-api/stores/getByMachinesId',
    'cre.cresys.ISUNG.adminOrder.listByUserMonth':	'/isung-order-adminapi/api/adminOrder/listByUserMonth',
    'cre.cresys.ISUNG.adminOrder.updateByOrderNo':	'/isung-order-adminapi/api/adminOrder/updateByOrderNo',
    'cre.cresys.ISUNG.adminOrder.exportByUserMonth':	'/isung-order-adminapi/api/adminOrder/exportByUserMonth',
    'cre.cresys.ISUNG.account.update':	'/isung-oauth-server/account/update',
    'cre.cresys.ISUNG.pickup.orderInfo':	'/isung-order-api/api/hnzczy/pickup/orderInfo',
    'cre.cresys.ISUNG.account.restPassword1':	'/isung-oauth-server/account/resetPassword1',
    'cre.cresys.ISUNG.account.resetPassword1':	'/isung-oauth-server/account/resetPassword1',
    'cre.cresys.ISUNG.logCollection':	'/isung-order-api/api/logCollection',
    'cre.cresys.ISUNG.importGoodMenu':	'/isung-order-adminapi/outlets/importGoodMenu',
    'cre.cresys.ISUNG.admin.goods.sync2Hnzczy':	'/isung-order-adminapi/goods/sync2Hnzczy'
  }[url]
}
// 封装post请求
export function fetch(requestUrl, params = '') {
  let param = {}
  if (requestUrl != 'cre.cresys.ISUNG.apiUser.add' && requestUrl != 'cre.cresys.ISUNG.account.info' && requestUrl != 'cre.cresys.ISUNG.nutrientBasedataList') {
    param = {Api_ID: requestUrl, params : params}
    params['Accept-Language'] = 'zh-HK'
  } else {
    let a = window.localStorage.getItem('AIIndex_Token')
    params.Authorization = JSON.parse(a)
    params['Accept-Language'] = 'zh-HK'
    param = {Api_ID: requestUrl, params : params}
  }
  
  return axios({
    // url: baseUrl,
    url: getUrl(requestUrl),
    method: 'POST',
    // data: {Api_ID: requestUrl, params : params},
    data: param,
  })
}